module.exports = __webpack_public_path__ + "img/playing.3504f891.gif";